import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { LoginService } from '@uoa/auth';

@Injectable({ providedIn: 'root' })
export class NzseisAdminGuard implements CanActivate {
  constructor(
    private readonly loginService: LoginService,
    private readonly router: Router,
  ) {}

  async canActivate(): Promise<boolean | UrlTree> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const userInfo = await this.loginService.getUserInfo() as any;
    const groups: string[] = (userInfo?.groups ?? []).map((g: string) => g.trim());
    if (!groups.includes('Nzseis_users')) {
      return this.router.createUrlTree(['/error/403']);
    }
    return true;
  }
}
